'use client'

import { ModelsNews } from '@/api/generated-api'
import { Link } from '@/i18n/routing'
import Image from '@/ui/MediaImage'

import { formatNewsRelativeTime, getNewsDisplayDate } from '../../utils/date'
import { getPrimaryNewsTagLabel } from '../../utils/newsTags'
import NewsCategoryBadge from '../NewsHeroFeatured/NewsCategoryBadge'
import S from './NewsGridCard.module.scss'

type NewsGridCardProps = {
  news: ModelsNews
  locale: string
}

const NewsGridCard = ({ news, locale }: NewsGridCardProps) => {
  const tagLabel = getPrimaryNewsTagLabel(news)
  const timeLabel = formatNewsRelativeTime(getNewsDisplayDate(news), locale)

  return (
    <Link href={`/news/${news.id}`} className={S.card}>
      <div className={S.image}>
        {news.header_image_url && (
          <Image
            src={news.header_image_url}
            alt={news.title || 'News image'}
            fill
            className={S.imageContent}
            sizes="(max-width: 768px) 50vw, 33vw"
          />
        )}
      </div>
      <div className={S.content}>
        <div className={S.metaRow}>
          {tagLabel && <NewsCategoryBadge label={tagLabel} />}
          {timeLabel && <span className={S.time}>{timeLabel}</span>}
        </div>
        <h3 className={S.title}>{news.title}</h3>
      </div>
    </Link>
  )
}

export default NewsGridCard
